export default __webpack_public_path__ + "static/media/illustration_carrier-bid-management.f22d1c86.svg";